<template>
  <div>
    <div class="large-empty no-patient" v-show="!selectedPatient.length">
      <i class="fa fa-info-circle fa-3x"></i>
      <span
        >Hasta detaylarını görmek için Hasta Listesinden hasta
        seçmelisiniz</span
      >
    </div>

    <div class="h-bar short" v-if="selectedPatient.length">
      <div class="name">
        {{ selectedPatient[0].name }}
        (<span class="c-orange">{{ selectedPatient[0].dosya }}</span
        >)
      </div>

      <div class="completed">
        <Progress
          :strokeColor="completed[1]"
          :strokeWidth="4"
          :radius="28"
          :value="completed[0]"
        >
          <div class="content" :class="'c-' + completed[1]">
            {{ completed[0] }}
          </div>
        </Progress>
      </div>

      <div class="tabs">
        <ul>
          <li
            @click.prevent="setTabActive(1)"
            :class="{ active: isTabActive(1) }"
          >
            Hasta Dosyası
          </li>
          <li
            @click.prevent="setTabActive(2)"
            :class="{ active: isTabActive(2) }"
          >
            Epikriz
          </li>
          <li
            id="yazdir-tab"
            @click.prevent="setTabActive(3)"
            :class="{ active: isTabActive(3) }"
          >
            Yazdır
          </li>
        </ul>
      </div>
    </div>
    <div id="content" class="servis-content" v-if="selectedPatient.length">
      <div id="tab-1" class="tab-content" v-show="isTabActive(1)">
        <div class="patient-profile card-40">
          <div class="patient-header">
            <div class="sex">
              <span class="bg-blue" v-show="selectedPatient[0].sex == 1">
                <i class="fa fa-lg fa-male"></i>
              </span>
              <span class="bg-pink" v-show="selectedPatient[0].sex == 2">
                <i class="fa fa-lg fa-female"></i>
              </span>
            </div>
            <div class="btn-group">
              <a v-show="isYatis" class="btn link-blue" @click="editYatis()">
                <i class="fa fa fa-edit"></i> Düzenle
              </a>
              <a
                class="btn link-red fr"
                v-show="isYatis && user.level == 1"
                @click.prevent="taburcu()"
              >
                <i class="fa fa fa-sign-out-alt"></i>
                Taburcu Et
              </a>
              <a
                class="btn link-red fr"
                v-show="!isYatis && user.level == 1"
                @click.prevent="removePatient()"
              >
                <i class="fa fa fa-trash"></i> Kaldır
              </a>
              <a
                class="btn link-blue"
                v-show="!isYatis && user.level == 1"
                @click.prevent="undotaburcu()"
              >
                <i class="fa fa fa-undo"></i> Geri Al
              </a>
            </div>
            <div class="name">
              {{ selectedPatient[0].name }}
            </div>
            <div class="age">
              {{ selectedPatient[0].birth | toYas }}
            </div>

            <ul class="bulgular">
              <li class="info">
                <span class="title">Ağırlık</span
                ><span class="value"> {{ selectedPatient[0].kg }} kg</span>
                <span class="persantil">{{
                  this.selectedPatient[0].kilop
                }}</span>
              </li>
              <li class="info">
                <span class="title">Boy</span
                ><span class="value"
                  >{{
                    selectedPatient[0].boy > 0
                      ? selectedPatient[0].boy + " cm"
                      : " - "
                  }}
                </span>
                <span class="persantil">{{
                  this.selectedPatient[0].boyp
                }}</span>
              </li>
              <li class="info">
                <span class="title">Baş Çevresi</span
                ><span class="value">{{
                  selectedPatient[0].bas > 0
                    ? selectedPatient[0].bas + " cm"
                    : " - "
                }}</span>
                <span class="persantil">{{
                  this.selectedPatient[0].basp
                }}</span>
              </li>
            </ul>

            <div class="details">
              <div class="tanilar">
                <div class="gun">
                  <p>
                    <b> {{ selectedPatient[0].yatis | toOnlyGun }}. </b>
                  </p>
                  <p>GÜN</p>
                </div>
                <span v-show="selectedPatient[0].tanilar != ''">{{
                  selectedPatient[0].tanilar
                }}</span>
                <span class="c-red" v-show="selectedPatient[0].tanilar == ''">
                  <i class="fa fa-exclamation-triangle"></i>
                  Tanı Girilmemiş
                </span>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="modal-overlay" v-if="editingYatis">
              <div class="modal-box small">
                <span class="close" @click="cancelYatis()">&times;</span>
                <h3>Düzenle</h3>
                <form v-on:submit.prevent autocomplete="off">
                  <div class="labeledit">
                    <label for="p-tanilar">Tanılar</label>
                    <input
                      type="text"
                      v-model="selectedPatient[0].tanilar"
                      id="p-tanilar"
                    />
                  </div>
                  <div class="labeledit">
                    <label for="p-dosya">Dosya No</label>
                    <input
                      type="number"
                      v-model.number="selectedPatient[0].dosya"
                      id="p-dosya"
                    />
                  </div>
                  <div class="labeledit">
                    <label for="p-adi">Adı Soyadı</label>
                    <input
                      type="text"
                      v-model="selectedPatient[0].name"
                      id="p-adi"
                    />
                  </div>
                  <div class="labeledit">
                    <label>Cinsiyet</label>

                    <div class="toggle-group">
                      <label class="selam" for="p-cinsiyet-1">
                        <input
                          id="p-cinsiyet-1"
                          type="radio"
                          value="1"
                          class="modern"
                          v-model="selectedPatient[0].sex"
                        />
                        <span>Erkek</span>
                      </label>

                      <label class="selam" for="p-cinsiyet-2">
                        <input
                          id="p-cinsiyet-2"
                          type="radio"
                          value="2"
                          class="modern"
                          v-model="selectedPatient[0].sex"
                        />
                        <span>Kız</span>
                      </label>
                    </div>
                  </div>
                  <div class="labeledit">
                    <label for="p-dogum">Doğum Tarihi</label>
                    <input
                      type="date"
                      v-model="selectedPatient[0].birth"
                      id="p-dogum"
                    />
                  </div>
                  <div class="labeledit">
                    <label for="p-yatis">Yatış Tarihi</label>
                    <input
                      type="date"
                      v-model="selectedPatient[0].yatis"
                      id="p-yatis"
                    />
                  </div>
                  <div class="labeledit">
                    <label>Yattığı Servis</label>
                    <div class="toggle-group vertical">
                      <label for="p-yer-1">
                        <input
                          id="p-yer-1"
                          class="modern"
                          type="radio"
                          value="1"
                          v-model="selectedPatient[0].yeri"
                        />
                        <span>Genel Servis</span>
                      </label>
                      <label for="p-yer-2">
                        <input
                          id="p-yer-2"
                          class="modern"
                          type="radio"
                          value="2"
                          v-model="selectedPatient[0].yeri"
                        />
                        <span>Kardiyoloji Servis</span>
                      </label>

                      <label for="p-yer-3">
                        <input
                          id="p-yer-3"
                          class="modern"
                          type="radio"
                          value="3"
                          v-model="selectedPatient[0].yeri"
                        />
                        <span>Nöroloji Servis</span>
                      </label>

                      <label for="p-yer-4">
                        <input
                          id="p-yer-4"
                          class="modern"
                          type="radio"
                          value="4"
                          v-model="selectedPatient[0].yeri"
                        />
                        <span>Nefroloji Servis</span>
                      </label>

                      <label for="p-yer-5">
                        <input
                          id="p-yer-5"
                          class="modern"
                          type="radio"
                          value="5"
                          v-model="selectedPatient[0].yeri"
                        />
                        <span>İzole Servis</span>
                      </label>

                      <label for="p-yer-6">
                        <input
                          id="p-yer-6"
                          class="modern"
                          type="radio"
                          value="6"
                          v-model="selectedPatient[0].yeri"
                        />
                        <span>Yoğun Bakım</span>
                      </label>
                    </div>
                  </div>

                  <div class="labeledit">
                    <label for="p-kilo">Yatış Kilosu (kg)</label>
                    <input
                      type="number"
                      v-model.number="selectedPatient[0].kg"
                      id="p-kilo"
                    />
                  </div>
                  <div class="labeledit">
                    <label for="p-boy">Boy (cm)</label>

                    <input
                      type="number"
                      v-model.number="selectedPatient[0].boy"
                      id="p-boy"
                    />
                  </div>

                  <div class="labeledit">
                    <label for="p-basc">Baş Çevresi (cm)</label>
                    <input
                      type="number"
                      v-model.number="selectedPatient[0].bas"
                      id="p-basc"
                    />
                  </div>
                </form>
                <div class="button-bar">
                  <a class="btn link-green fr" @click.prevent="saveYatis()">
                    <i class="fa fa fa-check"></i> Kaydet
                  </a>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
          </transition>
          <div class="y-special-data">
            <ul class="patient-infos">
              <li class="info">
                <div class="info-header">
                  <span class="title">ÖZGEÇMİŞ</span>
                  <a
                    class="btn link-blue"
                    v-show="
                      selectedPatient[0].ozgecmis != '' && !ozgecmis.editing
                    "
                    @click="editOzgecmis()"
                  >
                    <i class="fa fa fa-edit"></i>
                    Düzenle
                  </a>
                </div>
                <div
                  v-show="
                    selectedPatient[0].ozgecmis == '' && !ozgecmis.editing
                  "
                  class="small-empty"
                >
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span
                    >Yazmak için
                    <a class="c-red" @click="editOzgecmis('sablon')"
                      >tıklayın</a
                    ></span
                  >
                </div>
                <span
                  class="value"
                  v-show="
                    selectedPatient[0].ozgecmis != '' && !ozgecmis.editing
                  "
                >
                  {{ selectedPatient[0].ozgecmis }}
                </span>
                <div class="edit-form" v-if="ozgecmis.editing">
                  <form class="editing-form" v-on:submit.prevent>
                    <div class="labeledit">
                      <textarea-autosize
                        id="p-ozgecmis"
                        rows="7"
                        spellcheck="false"
                        v-model="ozgecmis.value"
                      />
                    </div>
                  </form>
                  <div class="btn-bar">
                    <a class="btn btn-green" @click="saveOzgecmis()">
                      <i class="fa fa fa-check"></i>
                      Kaydet
                    </a>
                    <a class="btn link-red" @click="ozgecmis.editing = false">
                      <i class="fa fa fa-times"></i> İptal
                    </a>
                  </div>
                </div>
              </li>
              <li class="info">
                <div class="info-header">
                  <span class="title">SOYGEÇMİŞ</span>
                  <a
                    class="btn link-blue"
                    v-show="
                      selectedPatient[0].soygecmis != '' && !soygecmis.editing
                    "
                    @click="editSoygecmis()"
                  >
                    <i class="fa fa fa-edit"></i>
                    Düzenle
                  </a>
                </div>
                <div
                  v-show="
                    selectedPatient[0].soygecmis == '' && !soygecmis.editing
                  "
                  class="small-empty"
                >
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span
                    >Yazmak için
                    <a class="c-red" @click="editSoygecmis('sablon')"
                      >tıklayın</a
                    ></span
                  >
                </div>
                <span
                  class="value"
                  v-show="
                    selectedPatient[0].soygecmis != '' && !soygecmis.editing
                  "
                >
                  {{ selectedPatient[0].soygecmis }}
                </span>
                <div class="edit-form" v-if="soygecmis.editing">
                  <form class="editing-form" v-on:submit.prevent>
                    <div class="labeledit">
                      <textarea-autosize
                        id="p-soygecmis"
                        rows="4"
                        spellcheck="false"
                        v-model="soygecmis.value"
                      />
                    </div>
                  </form>
                  <div class="btn-bar">
                    <a class="btn btn-green" @click="saveSoygecmis()">
                      <i class="fa fa fa-check"></i>
                      Kaydet
                    </a>
                    <a class="btn link-red" @click="soygecmis.editing = false">
                      <i class="fa fa fa-times"></i> İptal
                    </a>
                  </div>
                </div>
              </li>
              <li class="info">
                <div class="info-header">
                  <span class="title">MUAYENE</span>
                  <a
                    class="btn link-blue"
                    v-show="
                      selectedPatient[0].muayene != '' && !muayene.editing
                    "
                    @click="editMuayene()"
                  >
                    <i class="fa fa fa-edit"></i>
                    Düzenle
                  </a>
                </div>
                <div
                  v-show="selectedPatient[0].muayene == '' && !muayene.editing"
                  class="small-empty"
                >
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span
                    >Yazmak için
                    <a class="c-red" @click="editMuayene('sablon')"
                      >tıklayın</a
                    ></span
                  >
                </div>
                <span
                  class="value"
                  v-show="selectedPatient[0].muayene != '' && !muayene.editing"
                >
                  {{ selectedPatient[0].muayene }}
                </span>
                <div class="edit-form" v-if="muayene.editing">
                  <form class="editing-form" v-on:submit.prevent>
                    <div class="labeledit">
                      <textarea-autosize
                        id="p-muayene"
                        rows="4"
                        spellcheck="false"
                        v-model="muayene.value"
                      />
                    </div>
                  </form>
                  <div class="btn-bar">
                    <a class="btn btn-green" @click="saveMuayene()">
                      <i class="fa fa fa-check"></i>
                      Kaydet
                    </a>
                    <a class="btn link-red" @click="muayene.editing = false">
                      <i class="fa fa fa-times"></i>
                      İptal
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="patient-profile card-60">
          <div class="y-not-data" v-if="selectedPatient.length">
            <transition name="fade">
              <div class="modal-overlay" v-if="editingNot">
                <div class="modal-box medium">
                  <span class="close" @click="cancelNot()">&times;</span>
                  <h3>Düzenle</h3>
                  <form v-on:submit.prevent autocomplete="off">
                    <div class="labeledit">
                      <label for="p-notyatis">Yatış Tarihi</label>
                      <input
                        type="date"
                        v-model="selectedPatient[0].yatis"
                        id="p-notyatis"
                      />
                    </div>
                    <div class="labeledit">
                      <label for="p-sikayet">Şikayeti</label>
                      <input
                        type="text"
                        v-model="selectedPatient[0].sikayet"
                        id="p-sikayet"
                      />
                    </div>
                    <div class="labeledit">
                      <label for="p-gecmis">Bilinen Hastalık ve İlaçlar</label>
                      <input
                        type="text"
                        v-model="selectedPatient[0].gecmis"
                        id="p-gecmis"
                      />
                    </div>
                    <div class="labeledit vertical">
                      <label for="p-oyku">Öykü</label>
                    </div>
                    <div class="labeledit">
                      <textarea-autosize
                        id="p-oyku"
                        spellcheck="false"
                        v-model="selectedPatient[0].oyku"
                      />
                    </div>
                    <div class="labeledit vertical">
                      <label for="p-muayene">Muayene</label>
                    </div>
                    <div class="labeledit">
                      <textarea-autosize
                        id="p-muayene"
                        spellcheck="false"
                        v-model="selectedPatient[0].muayene"
                      />
                    </div>
                    <div class="labeledit vertical">
                      <label for="p-oneriler">Öneriler</label>
                    </div>
                    <div class="labeledit">
                      <textarea-autosize
                        id="p-oneriler"
                        v-model="selectedPatient[0].oneriler"
                      />
                    </div>
                    <div class="labeledit vertical">
                      <label for="p-dr">Yatıran Doktor</label>
                      <select id="p-dr" v-model="selectedPatient[0].dr">
                        <option :value="0">
                          (Yok)
                        </option>
                        <option
                          :value="d.id"
                          v-for="d in activedoctors"
                          :key="d.id"
                        >
                          Dr.{{ d.name }}
                        </option>
                      </select>
                    </div>
                  </form>
                  <div class="button-bar">
                    <a class="btn link-green fr" @click.prevent="saveNot()">
                      <i class="fa fa fa-check"></i>
                      Kaydet
                    </a>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </transition>
            <div class="info-header">
              <a
                class="btn link-indigo"
                v-show="!editingNot"
                @click.prevent="printYatisNotu()"
              >
                <i class="fa fa fa-print"></i> Yazdır
              </a>
              <a
                class="btn link-blue"
                v-show="isYatis && !editingNot && user.level == 1"
                @click="editNot()"
              >
                <i class="fa fa fa-edit"></i> Düzenle
              </a>
            </div>
            <div class="y-not" id="printYatisNotu">
              <p>
                <center>
                  <b>YATIŞ NOTU</b>
                </center>
              </p>
              <p style="text-align: right">
                <b>{{ selectedPatient[0].yatis | moment("DD.MM.YYYY") }}</b>
              </p>
              <p class="invisible">
                <b
                  >{{ selectedPatient[0].name }} ({{
                    selectedPatient[0].sex | toSex
                  }}, {{ selectedPatient[0].birth | toYas }},
                  {{ selectedPatient[0].kg }} KG)</b
                >
              </p>
              <p>ŞİKAYET : {{ selectedPatient[0].sikayet }}</p>
              <p>{{ selectedPatient[0].gecmis }}</p>
              <p>{{ selectedPatient[0].oyku }}</p>
              <ul>
                <li
                  v-for="m in selectedPatient[0].muayene.split('\n')"
                  :key="m"
                >
                  {{ m }}
                </li>
              </ul>
              <P
                >HASTANIN İLERİ TETKİK VE TEDAVİ AMACIYLA KONSÜLTAN ÖĞRETİM
                GÖREVLİSİNE DANIŞILARAK {{ yeri }} YATIŞI YAPILDI.</P
              >
              <p>ÖNERİLER</p>
              <ul>
                <li
                  v-for="o in selectedPatient[0].oneriler.split('\n')"
                  :key="o"
                >
                  {{ o }}
                </li>
              </ul>
              <p style="text-align: right">
                <b>{{
                  selectedPatient[0].dr > 0 ? "Dr." + yatirandr_name : ""
                }}</b>
              </p>
            </div>
          </div>
          <div class="y-readonly-data" style="display: none">
            <ul class="patient-infos">
              <li class="info">
                <div class="info-header">
                  <a class="btn link-blue" @click.prevent="saveYatis()">
                    Yatış Notu
                    <i class="fa fa fa-external-link-alt"></i>
                  </a>
                </div>
                <div class="hikaye">
                  <p>
                    <b>ŞİKAYETİ : </b>
                    {{ selectedPatient[0].sikayet }}
                  </p>
                  <p>{{ selectedPatient[0].gecmis }}</p>
                  <p>{{ selectedPatient[0].oyku }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="card card-40 card-flex" v-if="isYatis && user.level == 1">
          <p class="header bg-blue">Tedavi Planı</p>
          <ul class="tedavi-tabs">
            <li
              @click.prevent="setTedaviTabActive(1)"
              :class="{ active: isTedaviTabActive(1) }"
            >
              Öneriler
            </li>
            <li
              @click.prevent="setTedaviTabActive(2)"
              :class="{ active: isTedaviTabActive(2) }"
            >
              Mayiler
            </li>
            <li
              @click.prevent="setTedaviTabActive(3)"
              :class="{ active: isTedaviTabActive(3) }"
            >
              Harriet Lane
            </li>
          </ul>
          <div class="y-tedavi-plan">
            <div class="col" v-show="isTedaviTabActive(1)">
              <ul class="oneriler">
                <li
                  v-for="o in selectedPatient[0].oneriler.split('\n')"
                  :key="o"
                >
                  <a class="btn link-green" @click.prevent="addOneriler(o)">
                    <i class="fa fa fa-plus"></i>
                    <span>{{ o }}</span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="col" v-show="isTedaviTabActive(2)">
              <ul class="sablon">
                <li class="info">
                  <span class="title">İdame (KG Hesabı)</span
                  ><span class="value"> {{ mayi[0] }} cc/h</span>
                </li>
                <li class="info">
                  <span class="title">Vücut m2</span
                  ><span class="value"> {{ mayi[1] }} m2</span>
                </li>
                <li class="info">
                  <span class="title">1500 cc/m2</span
                  ><span class="value"> {{ mayi[2] }} cc/h</span>
                </li>
                <li class="info">
                  <span class="title">2000 cc/m2</span
                  ><span class="value"> {{ mayi[3] }} cc/h</span>
                </li>
                <li class="info">
                  <span class="title">2500 cc/m2</span
                  ><span class="value"> {{ mayi[4] }} cc/h</span>
                </li>
                <li class="info">
                  <span class="title">3000 cc/m2</span
                  ><span class="value"> {{ mayi[5] }} cc/h</span>
                </li>
              </ul>
            </div>
            <div class="col" v-show="isTedaviTabActive(3)">
              <ul class="drugs">
                <FsLightbox
                  :toggler="toggler"
                  :sources="drugImages"
                  type="image"
                />
                <div class="search-box">
                  <input
                    type="search"
                    v-model="drug"
                    placeholder="Harriet Lane ilaç ara"
                  />
                </div>
                <div class="small-empty" v-show="!drugList.length">
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span>İlaç Aratmaya Başlayın</span>
                </div>
                <li v-for="d in drugList" :key="d.id" class="drug">
                  <a @click="showDrug(d)"
                    ><i class="fa fa-pills"></i> {{ d.name }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card card-60" v-if="isYatis && user.level == 1">
          <p class="header" :class="modifiedDevir ? 'bg-blue' : 'bg-green'">
            Devir Notu
            <transition name="fade">
              <a
                class="header-btn btn btn-blue"
                v-show="modifiedDevir"
                @click="saveDevir()"
              >
                <i class="fa fa fa-save"></i> Güncelle
              </a>
            </transition>
          </p>
          <div class="modal-overlay" v-if="tedavi.mode != 0">
            <div class="modal-box small">
              <span class="close" @click="closeTedavi()">&times;</span>
              <h3>
                {{ tedavi.mode == 1 ? "Yeni Tedavi" : "Düzenle" }}
              </h3>
              <form v-on:submit.prevent>
                <div class="labeledit">
                  <label>Gün Takibi</label>
                  <div class="toggle-group">
                    <label for="p-gun-1">
                      <input
                        id="p-gun-1"
                        class="modern"
                        type="radio"
                        value="1"
                        v-model="tedavi.veri.gun"
                      />
                      <span>Evet</span>
                    </label>

                    <label for="p-gun-2">
                      <input
                        id="p-gun-2"
                        class="modern"
                        type="radio"
                        value="2"
                        v-model="tedavi.veri.gun"
                      />
                      <span>Hayır</span>
                    </label>
                  </div>
                </div>
                <div class="labeledit">
                  <label for="p-baslama">Başlama Tarihi</label>
                  <input
                    type="date"
                    v-model="tedavi.veri.tarih"
                    id="p-baslama"
                  />
                </div>
                <div class="labeledit">
                  <label for="p-tdv">Tedavi ve Doz</label>
                  <div class="multi-input">
                    <input
                      type="text"
                      placeholder="Tedavi"
                      v-model="tedavi.veri.tedavi"
                      id="p-tdv"
                    />
                    <div class="space"></div>
                    <input
                      type="text"
                      placeholder="Doz"
                      v-model="tedavi.veri.doz"
                      id="p-doz"
                    />
                  </div>
                </div>
              </form>
              <div class="button-bar">
                <a
                  class="btn btn-red fl"
                  v-show="tedavi.mode == 2"
                  @click.prevent="stopTedavi()"
                >
                  <i class="fa fa fa-ban"></i> Stopla
                </a>
                <a class="btn link-green fr" @click.prevent="saveTedavi()">
                  <i class="fa fa fa-check"></i> Kaydet
                </a>
                <div class="clear"></div>
              </div>
            </div>
          </div>
          <div class="y-devir">
            <div class="devir-bar">
              <div class="fr">
                <input
                  type="text"
                  class="oda-input"
                  placeholder="Oda No"
                  v-model="selectedPatient[0].oda"
                  @input="modifiedDevir = true"
                />
              </div>
              <div class="clear"></div>
            </div>
            <div class="content">
              <p>
                TANI :
                <b>{{ selectedPatient[0].tanilar }}</b>
              </p>
              <p>
                YATIŞ :
                <b>{{ selectedPatient[0].yatis | toGun }}</b>
              </p>
            </div>

            <div class="tedaviler">
              <div class="info-header">
                <span class="title">TEDAVİLER</span>
                <a class="btn link-green fr" @click.prevent="addTedavi()">
                  <i class="fa fa fa-plus"></i> Ekle
                </a>
              </div>
              <div v-if="!selectedPatient[1].length" class="small-empty">
                <i class="fa fa-exclamation-triangle fa-3x"></i>
                <span>Henüz tedavi başlanmadı</span>
              </div>
              <ul v-if="selectedPatient[1].length">
                <li
                  v-for="t in selectedPatient[1]"
                  :key="t.id"
                  @click="editTedavi(t.id)"
                  :class="t.gun == 1 ? 'b-highligted1' : ''"
                >
                  {{ t.tedavi }}
                  {{ t.doz != "" ? "(" + t.doz + ")" : "" }}
                  <b>{{ (t.gun == 1 ? t.tarih : "") | toGun }}</b>
                </li>
              </ul>
            </div>
            <div class="devir-box">
              <p>
                <b>TETKİKLER</b>
              </p>
              <div>
                <textarea-autosize
                  spellcheck="false"
                  placeholder="Tetkik Takipleri"
                  v-model="selectedPatient[0].devir"
                  rows="4"
                  @input.native="modifiedDevir = true"
                />
              </div>
            </div>
            <div class="devir-box">
              <p>
                <b>TAKİPLER VE PLAN</b>
              </p>
              <div>
                <textarea-autosize
                  spellcheck="false"
                  placeholder="Takipler ve Plan"
                  v-model="selectedPatient[0].plan"
                  rows="6"
                  @input.native="modifiedDevir = true"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-if="isYatis">
          <div class="date-bar" :class="progress.is ? 'bg-green' : 'bg-red'">
            <a
              class="t-blue"
              v-show="!editingProgress"
              @click.prevent="navigateProgress(-1)"
            >
              <i class="fa fa-2x fa-angle-left"></i>
            </a>
            <transition name="slide-fade" mode="out-in">
              <label :key="progressDate.toString()">{{
                progressDate | moment("DD MMMM YYYY")
              }}</label>
            </transition>
            <a
              class="t-blue"
              v-show="!editingProgress"
              @click.prevent="navigateProgress(1)"
            >
              <i class="fa fa-2x fa-angle-right"></i>
            </a>
          </div>

          <div class="seyir-bar" v-if="progress.is || editingProgress">
            <a
              class="btn link-purple"
              v-show="!editingProgress"
              v-clipboard:success="onCopy"
              v-clipboard:copy="
                this.$moment(progress.veri.tarih).format('DD.MM.YYYY') +
                  '\n' +
                  progress.veri.baslik +
                  '\n' +
                  progress.veri.progress
              "
            >
              <i class="fa fa fa-copy"></i> Kopyala
            </a>
            <a
              class="btn link-blue"
              v-show="!editingProgress && user.level == 1"
              @click="editProgress()"
            >
              <i class="fa fa fa-edit"></i> Düzenle
            </a>
            <a
              class="btn link-red"
              v-show="!editingProgress && user.level == 1"
              @click="deleteProgress()"
            >
              <i class="fa fa fa-trash"></i> Sil
            </a>
            <a
              class="btn link-green"
              v-show="editingProgress && user.level == 1"
              @click="saveProgress()"
            >
              <i class="fa fa fa-check"></i> Kaydet
            </a>
            <a
              class="btn link-red"
              v-show="editingProgress && user.level == 1"
              @click="cancelProgress()"
            >
              <i class="fa fa fa-times"></i> İptal
            </a>
          </div>
          <div class="y-progress">
            <div v-if="progress.is && !editingProgress">
              <div class="written">
                <i class="fa fa-lg fa-marker"></i>
                Dr.{{ progress.veri.asistan_name }}
              </div>
              <p class="bold">{{ progress.veri.baslik }}</p>
              <p>{{ progress.veri.progress }}</p>
            </div>
            <div v-if="!progress.is && !editingProgress" class="small-empty">
              <i class="fa fa-info-circle fa-3x"></i>
              <span>
                Bugüne ait progress yazılmamış.
                <span v-if="user.level == 1">
                  Yazmak için
                  <a class="c-red" @click="addProgress()">tıklayın</a>
                </span>
              </span>
            </div>
            <form v-on:submit.prevent v-if="editingProgress" action>
              <div class="labeledit">
                <select id="p-dr" v-model="progress.veri.asistan">
                  <option :value="0">(Yok)</option>
                  <option :value="d.id" v-for="d in activedoctors" :key="d.id">
                    Dr.{{ d.name }}
                  </option>
                </select>
              </div>
              <div class="labeledit">
                <textarea-autosize
                  spellcheck="false"
                  id="p-baslik"
                  rows="3"
                  class="bold"
                  v-model="progress.veri.baslik"
                />
              </div>
              <div class="labeledit">
                <textarea-autosize
                  spellcheck="false"
                  id="p-progress"
                  rows="9"
                  class="seyir-area"
                  v-model="progress.veri.progress"
                  placeholder="Hastanın Klinik Seyri"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      <div id="tab-2" class="tab-content" v-show="isTabActive(2)">
        <div class="card card-fw">
          <div>
            <div class="y-ozet">
              <p>
                <span class="key">
                  <span>ŞİKAYETİ</span>
                  <a
                    class="btn link-blue fr"
                    v-clipboard:copy="selectedPatient[0].sikayet"
                  >
                    <i class="fa fa fa-copy"></i> Kopyala
                  </a>
                </span>
                <span class="value">{{ selectedPatient[0].sikayet }}</span>
              </p>
              <p>
                <span class="key">
                  <span>YATIŞ HİKAYESİ</span>
                  <a
                    class="btn link-blue fr"
                    v-clipboard:copy="selectedPatient[0].oyku"
                  >
                    <i class="fa fa fa-copy"></i> Kopyala
                  </a>
                </span>
                <span class="value">{{ selectedPatient[0].oyku }}</span>
              </p>
              <p>
                <span class="key">
                  <span>ÖZGEÇMİŞ</span>
                  <a
                    class="btn link-blue fr"
                    v-clipboard:copy="selectedPatient[0].ozgecmis"
                  >
                    <i class="fa fa fa-copy"></i> Kopyala
                  </a>
                </span>
                <span class="value">{{ selectedPatient[0].ozgecmis }}</span>
                <span
                  v-show="selectedPatient[0].ozgecmis == ''"
                  class="small-empty"
                >
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span>Özgeçmiş yazılmamış </span>
                </span>
              </p>
              <p>
                <span class="key">
                  <span>SOYGEÇMİŞ</span>
                  <a
                    class="btn link-blue fr"
                    v-clipboard:copy="selectedPatient[0].soygecmis"
                  >
                    <i class="fa fa fa-copy"></i> Kopyala
                  </a>
                </span>
                <span class="value">{{ selectedPatient[0].soygecmis }}</span>
                <span
                  v-show="selectedPatient[0].soygecmis == ''"
                  class="small-empty"
                >
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span>Soygeçmiş yazılmamış </span>
                </span>
              </p>
              <p>
                <span class="key">
                  <span>MUAYENE</span>
                  <a
                    class="btn link-blue fr"
                    v-clipboard:copy="selectedPatient[0].muayene"
                  >
                    <i class="fa fa fa-copy"></i> Kopyala
                  </a>
                </span>
                <span class="value">{{ selectedPatient[0].muayene }}</span>
              </p>
              <p>
                <span class="key">
                  <span>BULGULAR</span>
                  <a class="btn link-blue fr" v-clipboard:copy="epikriz_bulgu">
                    <i class="fa fa fa-copy"></i> Kopyala
                  </a>
                </span>
                <span id="ozet-bulgu" class="value">{{ epikriz_bulgu }}</span>
              </p>
              <p>
                <span class="key">
                  <span>KLİNİK SEYİR</span>
                  <a
                    class="btn link-blue fr"
                    v-clipboard:copy="epikriz_klinikseyir"
                  >
                    <i class="fa fa fa-copy"></i> Kopyala
                  </a>
                </span>
                <span id="ozet-klinikseyir" class="value">{{
                  epikriz_klinikseyir
                }}</span>
              </p>
              <p>
                <span class="key">
                  TEDAVİ VE ÖNERİLER (Şablon)
                  <a class="btn link-blue fr" v-clipboard:copy="sablon.taburcu">
                    <i class="fa fa fa-copy"></i> Kopyala
                  </a>
                </span>
                <span class="value">{{ sablon.taburcu }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="tab-3" class="tab-content" v-show="isTabActive(3)">
        <div id="progress-view" class="card">
          <p class="header">Progress Yazdır</p>
          <div class="topbar" v-if="selectedPatient[2].length > 0">
            <a
              class="btn link-blue"
              v-show="sprogress.length != selectedPatient[2].length"
              @click="selectProgress()"
            >
              <i class="fa fa fa-check-double"></i> Tüm Günleri Seç
            </a>
            <a
              class="btn link-blue"
              v-show="
                (sprogress.length == selectedPatient[2].length) &
                  (sprogress.length > 0)
              "
              @click="selectProgress()"
            >
              <i class="fa fa fa-check-double"></i> Tüm Günleri Seçmeyi Bırak
            </a>
            <a
              v-show="sprogress.length > 0"
              class="btn link-indigo"
              @click="printProgress()"
            >
              <i class="fa fa fa-print"></i> Seçili Günleri Yazdır
            </a>
          </div>
          <div class="y-page">
            <div class="page-back">
              <div id="pra-prog" class="page">
                <div class="b-name"></div>
                <div
                  v-for="e in orderedSelectedProgress"
                  :key="e.id"
                  class="progress"
                  :class="e.visible ? '' : 'hidden'"
                >
                  <input type="checkbox" v-model="e.visible" />
                  <div class="left">
                    <b>{{ e.tarih | moment("DD.MM.YYYY") }}</b>
                    <br />
                    Dr.{{ e.asistan_name }}
                  </div>
                  <div class="right">
                    {{ selectedPatient[0].name }}
                    <br />
                    {{ e.baslik }}
                    <br />
                    {{ e.progress }}
                  </div>
                </div>
              </div>
            </div>
            <div class="list">
              <center>
                <h3>Progress Listesi</h3>
              </center>

              <div class="toggle-group vertical">
                <template v-for="e in selectedPatient[2]">
                  <label :for="'p-epi-' + e.id" :key="e.id">
                    <input
                      :id="'p-epi-' + e.id"
                      class="modern"
                      type="checkbox"
                      :value="e"
                      v-model="sprogress"
                    />
                    <span>{{ e.tarih | moment("DD MMMM YYYY") }}</span>
                  </label>
                </template>
                <div v-if="selectedPatient[2].length == 0" class="small-empty">
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span>Henüz progress yazılmamış</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import _ from "lodash";
import Progress from "easy-circular-progress/src/index.vue";
import FsLightbox from "fslightbox-vue";
export default {
  name: "Servis",
  components: {
    Progress,
    FsLightbox,
  },
  data() {
    return {
      drug: "",
      drugImages: [],
      toggler: false,
      activeTab: 1,
      activeTedaviTab: 1,
      selectedPatient: [],
      sprogress: [],
      editingYatis: false,
      editingNot: false,
      editingProgress: false,
      modifiedDevir: false,
      ozgecmis: {
        editing: false,
        value: "",
      },
      soygecmis: {
        editing: false,
        value: "",
      },
      muayene: {
        editing: false,
        value: "",
      },
      progressDate: this.$moment(new Date()),
      patientsOpen: false,
      tedavi: {
        mode: 0,
        veri: {},
      },
      progress: {
        is: false,
        veri: {},
      },
    };
  },
  watch: {
    progressDate: {
      deep: true,
      immediate: false,
      handler: function() {
        this.progress = this.getProgress(this.progressDate);
      },
    },
  },
  computed: {
    doctors() {
      return this.$store.getters.getDoctors;
    },
    activedoctors() {
      return this.$store.getters.getActiveDoctors;
    },
    user() {
      return this.$store.getters.getUser;
    },
    sablon() {
      return this.$store.getters.getSablon;
    },
    drugList() {
      if (this.drug == "") {
        return "";
      } else {
        if (this.drug.length > 2) {
          let apis = this.$store.getters.getDrugs;
          let toSearch = this.drug.toLowerCase();
          let result = _.filter(apis, (o) =>
            o.name.toLowerCase().includes(toSearch)
          );
          return result;
        } else {
          return "";
        }
      }
    },
    completed() {
      var percent = 0;
      var color = "red";
      percent += this.selectedPatient[0].tanilar != "" ? 20 : 0;
      percent += this.selectedPatient[0].kg > 0 ? 20 : 0;
      percent += this.selectedPatient[0].boy > 0 ? 20 : 0;
      percent += this.selectedPatient[0].ozgecmis != "" ? 20 : 0;
      percent += this.selectedPatient[0].soygecmis != "" ? 20 : 0;
      if (percent > 50) {
        color = "orange";
      }
      if (percent == 100) {
        color = "green";
      }
      return [percent, color];
    },
    yeri() {
      if (this.selectedPatientID > -1) {
        return this.$store.getters.getServis(this.selectedPatient[0].yeri);
      } else {
        return "";
      }
    },
    mayi() {
      var kg = Number(this.selectedPatient[0].kg);
      var m2 = (4 * kg + 7) / (90 + kg);
      var kg_hesap = 0;
      if (kg > 0) {
        switch (true) {
          case kg <= 10:
            kg_hesap = (100 * kg) / 24;
            break;
          case kg > 10 && kg <= 20:
            kg_hesap = (1000 + 50 * (kg - 10)) / 24;
            break;
          case kg > 20:
            kg_hesap = (1500 + 20 * (kg - 20)) / 24;
            break;
        }
      } else {
        m2 = 0;
      }
      return [
        Math.round(kg_hesap),
        Math.round(m2 * 100) / 100,
        Math.round((1500 * m2) / 24),
        Math.round((2000 * m2) / 24),
        Math.round((2500 * m2) / 24),
        Math.round((3000 * m2) / 24),
      ];
    },

    selectedPatientID() {
      if (this.selectedPatient.length) {
        return this.selectedPatient[0].id;
      } else {
        return -1;
      }
    },
    isYatis() {
      if (this.selectedPatient.length) {
        var r;
        switch (this.selectedPatient[0].isyatis) {
          case 1:
            r = true;
            break;

          case 0:
            r = false;
            break;
        }
        return r;
      } else {
        return -1;
      }
    },
    yatirandr_name() {
      if (this.selectedPatientID > -1) {
        return this.$store.getters.getDRName(this.selectedPatient[0].dr);
      } else {
        return "";
      }
    },
    epikriz_bulgu() {
      if (this.selectedPatientID > -1) {
        var kg =
          this.selectedPatient[0].kg > 0
            ? "YATIŞ KİLOSU : " +
              this.selectedPatient[0].kg +
              " KG (" +
              this.selectedPatient[0].kilop +
              ")\n"
            : "";
        var boy =
          this.selectedPatient[0].boy > 0
            ? "BOY : " +
              this.selectedPatient[0].boy +
              " CM (" +
              this.selectedPatient[0].boyp +
              ")\n"
            : "";
        var basc =
          this.selectedPatient[0].bas > 0
            ? "BAŞ ÇEVRESİ : " +
              this.selectedPatient[0].bas +
              " CM (" +
              this.selectedPatient[0].basp +
              ")\n"
            : "";
        return kg + boy + basc;
      } else {
        return "";
      }
    },
    epikriz_klinikseyir() {
      if (this.selectedPatientID > -1) {
        var r;
        r =
          this.$moment(this.selectedPatient[0].yatis).format("DD.MM.YYYY") +
          "\n";
        r += "YATIŞ NOTU" + "\n";
        r += "ŞİKAYET : " + this.selectedPatient[0].sikayet + "\n";
        r += this.selectedPatient[0].gecmis + "\n";
        r += this.selectedPatient[0].oyku + "\n";
        r += "MUAYENE : " + "\n";
        r += this.selectedPatient[0].muayene + "\n";
        r +=
          "HASTANIN İLERİ TETKİK VE TEDAVİ AMACIYLA KONSÜLTAN ÖĞRETİM GÖREVLİSİNE DANIŞILARAK " +
          this.yeri +
          " YATIŞI YAPILDI." +
          "\n";
        r += "ÖNERİLER : " + "\n";
        r += this.selectedPatient[0].oneriler + "\n" + "\n";
        this.orderedProgresses.forEach((item) => {
          r += this.$moment(item.tarih).format("DD.MM.YYYY") + "\n";
          r += item.baslik + "\n";
          r += item.progress + "\n" + "\n";
        });
        return r;
      } else {
        return "";
      }
    },
    orderedProgresses: function() {
      return _.orderBy(this.selectedPatient[2], "tarih");
    },
    orderedSelectedProgress: function() {
      return _.orderBy(this.sprogress, "tarih");
    },
  },
  methods: {
    // Tabs
    isTabActive(menuItem) {
      return this.activeTab === menuItem;
    },
    setTabActive(menuItem) {
      this.activeTab = menuItem;
    },

    // Search Drug
    showDrug(ilac) {
      this.drugImages = [];
      let self = this;
      let imgs = ilac.files.split(",");
      imgs.forEach(function(entry) {
        self.drugImages.push("https://pediatrim.net/HL/HL-" + entry + ".jpg");
      });

      this.toggler = !this.toggler;
    },
    // Tedavi Tabs
    isTedaviTabActive(menuItem) {
      return this.activeTedaviTab === menuItem;
    },
    setTedaviTabActive(menuItem) {
      this.activeTedaviTab = menuItem;
    },

    patient_status(p) {
      var r = "";
      switch (parseInt(p)) {
        case 1:
          r = "finished";
          break;
        case 0:
          r = "unfinished";
          break;
        case -1:
          r = "taburcu";
          break;
      }
      return r;
    },
    getList() {
      this.$socket.client.emit("update", "patients");
      this.$store.dispatch("fillPatients");
    },
    getPatient(p, onlyRefresh = true) {
      if (p > -1) {
        let self = this;
        this.$http
          .get("api/get-patient.php", {
            params: {
              id: p,
            },
          })
          .then(function(response) {
            response.data.data.progress.forEach((p) => (p.visible = true));
            self.selectedPatient = Array(
              response.data.data.patient,
              response.data.data.tedavi,
              response.data.data.progress
            );
            self.patientsOpen = false;
            if (!onlyRefresh) {
              self.progressDate = self.$moment(new Date());
            } else {
              self.progress = self.getProgress(self.progressDate);
            }
            self.editingProgress = false;
            self.editingYatis = false;
            self.editingNot = false;
            self.tedavi.mode = 0;
            self.sprogress = [];
          });
      } else {
        this.selectedPatient = [];
      }
    },
    // Yatış Bilgileri
    taburcu() {
      if (confirm("Hasta taburcu edilecek. Devam etmek istiyor musunuz?")) {
        this.selectedPatient[0].isyatis = 0;
        this.selectedPatient[0].taburcudate = this.$moment(new Date()).format(
          "YYYY-MM-DD"
        );
        this.saveisYatis();
      }
    },
    undotaburcu() {
      if (
        confirm(
          "Hastaya tekrardan yatış verilecek. Devam etmek istiyor musunuz?"
        )
      ) {
        this.selectedPatient[0].isyatis = 1;
        this.selectedPatient[0].taburcudate = "";
        this.saveisYatis();
      }
    },
    removePatient() {
      if (confirm("Hasta sistemden silinecek. Devam etmek istiyor musunuz?")) {
        this.$http({
          method: "post",
          url: "api/edit-patient.php",
          data: qs.stringify({
            id: this.selectedPatient[0].id,
            q: "remove",
          }),
        }).then(() => {
          this.$snotify.success("Hasta sistemden silindi");
          this.$router.push("/patients/servis");
        });
      }
    },
    editYatis() {
      this.editingYatis = true;
    },
    cancelYatis() {
      this.editingYatis = false;
      this.getPatient(this.selectedPatientID);
    },
    saveisYatis() {
      this.$http({
        method: "post",
        url: "api/edit-patient.php",
        data: qs.stringify({
          id: this.selectedPatient[0].id,
          isyatis: this.selectedPatient[0].isyatis,
          taburcudate: this.selectedPatient[0].taburcudate,
          q: "isyatis",
        }),
      }).then(() => {
        this.$snotify.success("Yatış durumu güncellendi");
        this.$router.push("/patients/servis");
        this.getList();
      });
    },
    // Ozgecmis ve Soygecmis
    editOzgecmis(type) {
      this.ozgecmis.editing = true;
      this.ozgecmis.value = JSON.parse(
        JSON.stringify(this.selectedPatient[0].ozgecmis)
      );
      if (type == "sablon") {
        this.ozgecmis.value = this.sablon.ozgecmis;
      }
    },
    saveOzgecmis() {
      this.$http({
        method: "post",
        url: "api/edit-patient.php",
        data: qs.stringify({
          id: this.selectedPatient[0].id,
          ozgecmis: this.ozgecmis.value,
          q: "ozgecmis",
        }),
      }).then(() => {
        this.$snotify.success("Özgeçmiş güncellendi");
        this.selectedPatient[0].ozgecmis = this.ozgecmis.value;
        this.ozgecmis.editing = false;
      });
    },
    editSoygecmis(type) {
      this.soygecmis.editing = true;
      this.soygecmis.value = JSON.parse(
        JSON.stringify(this.selectedPatient[0].soygecmis)
      );
      if (type == "sablon") {
        this.soygecmis.value = this.sablon.soygecmis;
      }
    },
    saveSoygecmis() {
      this.$http({
        method: "post",
        url: "api/edit-patient.php",
        data: qs.stringify({
          id: this.selectedPatient[0].id,
          soygecmis: this.soygecmis.value,
          q: "soygecmis",
        }),
      }).then(() => {
        this.$snotify.success("Soygeçmiş güncellendi");
        this.selectedPatient[0].soygecmis = this.soygecmis.value;
        this.soygecmis.editing = false;
      });
    },
    editMuayene(type) {
      this.muayene.editing = true;
      this.muayene.value = JSON.parse(
        JSON.stringify(this.selectedPatient[0].muayene)
      );
      if (type == "sablon") {
        this.muayene.value = this.sablon.muayene;
      }
    },
    saveMuayene() {
      this.$http({
        method: "post",
        url: "api/edit-patient.php",
        data: qs.stringify({
          id: this.selectedPatient[0].id,
          muayene: this.muayene.value,
          q: "muayene",
        }),
      }).then(() => {
        this.$snotify.success("Muayene güncellendi");
        this.selectedPatient[0].muayene = this.muayene.value;
        this.muayene.editing = false;
      });
    },
    saveYatis() {
      var veri = JSON.parse(JSON.stringify(this.selectedPatient[0]));
      veri.q = "yatis";
      this.$http({
        method: "post",
        url: "api/edit-patient.php",
        data: qs.stringify(veri),
      }).then(() => {
        this.$snotify.success("Yatış bilgileri güncellendi");
        this.getList();
        this.getPatient(this.selectedPatientID);
      });
    },
    // Tedaviler
    closeTedavi() {
      this.tedavi.mode = 0;
      this.getPatient(this.selectedPatientID);
    },
    addTedavi() {
      this.tedavi.mode = 1;
      this.tedavi.veri = {
        q: "add",
        gun: 2,
        tedavi: "",
        doz: "",
        hasta: this.selectedPatientID,
        tarih: this.$moment(new Date()).format("YYYY-MM-DD"),
      };
    },
    addOneriler(oneri) {
      this.tedavi.mode = 1;
      this.tedavi.veri = {
        q: "add",
        gun: 2,
        tedavi: oneri,
        doz: "",
        hasta: this.selectedPatientID,
        tarih: this.$moment(new Date()).format("YYYY-MM-DD"),
      };
    },
    editTedavi(id) {
      this.tedavi.mode = 2;
      this.tedavi.veri = this.selectedPatient[1].find((t) => t.id === id);
      this.tedavi.veri.q = "edit";
    },
    stopTedavi() {
      let self = this;
      this.$http({
        method: "post",
        url: "api/tedavi.php",
        data: qs.stringify({
          id: this.tedavi.veri.id,
          q: "stop",
        }),
      }).then(() => {
        self.$snotify.success("Tedavi başarıyla stoplandı");
        self.tedavi.mode = 0;
        self.getPatient(this.selectedPatientID);
      });
    },
    saveTedavi() {
      this.$http({
        method: "post",
        url: "api/tedavi.php",
        data: qs.stringify(this.tedavi.veri),
      }).then(() => {
        this.$snotify.success("Tedavi başarıyla kaydedildi");
        this.tedavi.mode = 0;
        this.getPatient(this.selectedPatientID);
      });
    },
    // Devir Notu
    saveDevir() {
      var veri = JSON.parse(JSON.stringify(this.selectedPatient[0]));
      veri.q = "devir";
      this.$http({
        method: "post",
        url: "api/edit-patient.php",
        data: qs.stringify(veri),
      }).then(() => {
        this.$snotify.success("Devir Notu güncellendi");
        this.modifiedDevir = false;
        this.getPatient(this.selectedPatientID);
        this.getList();
      });
    },
    // Progress
    getProgress(d) {
      var r;
      r = {
        veri: this.selectedPatient[2].find(
          (t) =>
            t.tarih ===
            this.$moment(d)
              .format("YYYY-MM-DD")
              .toString()
        ),
      };
      if (r.veri == undefined) {
        r.is = false;
      } else {
        r.is = true;
      }
      return r;
    },
    navigateProgress(step) {
      if (
        this.$moment(
          this.$moment(this.progressDate).add(step, "days")
        ).isBetween(this.selectedPatient[0].yatis, new Date())
      ) {
        this.progressDate = this.$moment(this.progressDate).add(step, "days");
      }
    },
    editProgress() {
      this.editingProgress = true;
      this.progress.veri.q = "edit";
    },
    gunFarki(b1, b2) {
      var days = this.$moment(b2).diff(this.$moment(b1), "days", true);
      return Math.ceil(days) + ".GÜN";
    },
    addProgress() {
      // Sablon oluştur
      var yatisgun = this.gunFarki(
        this.selectedPatient[0].yatis,
        this.progressDate
      );
      // Tedavi şablonu
      let self = this;
      var tedaviler = "";
      var guntedaviler = "";
      this.selectedPatient[1].forEach(function(arrayItem) {
        if (arrayItem.gun == 1) {
          var abgun = self.gunFarki(arrayItem.tarih, self.progressDate);
          guntedaviler +=
            "\n" +
            arrayItem.tedavi +
            (arrayItem.doz == "" ? " " : " (" + arrayItem.doz + ") ") +
            abgun +
            "ÜNDE";
        } else {
          tedaviler +=
            arrayItem.tedavi +
            (arrayItem.doz == "" ? "" : " " + arrayItem.doz) +
            ",";
        }
      });

      // Önceki progress
      var prev = this.getProgress(
        this.$moment(this.progressDate).add(-1, "days")
      );
      var previous;
      if (prev.is) {
        previous = prev.veri.progress;
      } else {
        previous = "";
      }
      var sablon =
        "TANI : " +
        this.selectedPatient[0].tanilar +
        "\n" +
        "TEDAVİLER : " +
        tedaviler +
        "\n" +
        "YATIŞ : " +
        yatisgun +
        "Ü" +
        guntedaviler;
      this.editingProgress = true;
      this.progress.veri = {
        q: "add",
        baslik: sablon,
        progress: previous,
        hasta: this.selectedPatientID,
        tarih: this.$moment(this.progressDate).format("YYYY-MM-DD"),
        asistan_name: this.user.name,
        asistan: this.user.id,
      };
    },
    saveProgress() {
      this.$http({
        method: "post",
        url: "api/progress.php",
        data: qs.stringify(this.progress.veri),
      }).then(() => {
        this.$snotify.success("Klinik Seyir kaydedildi");
        this.getList();
        this.getPatient(this.selectedPatientID);
      });
    },
    deleteProgress() {
      if (confirm("Seçili progress silinecek. Devam etmek istiyor musunuz?")) {
        this.$http({
          method: "post",
          url: "api/progress.php",
          data: qs.stringify({
            id: this.progress.veri.id,
            q: "delete",
          }),
        }).then(() => {
          this.$snotify.success("Klinik Seyir silindi");
          this.getList();
          this.getPatient(this.selectedPatientID);
        });
      }
    },
    cancelProgress() {
      this.editingProgress = false;
      this.getPatient(this.selectedPatientID);
    },
    // Yatış Notu
    editNot() {
      this.editingNot = true;
    },
    saveNot() {
      var veri = JSON.parse(JSON.stringify(this.selectedPatient[0]));
      veri.q = "not";
      this.$http({
        method: "post",
        url: "api/edit-patient.php",
        data: qs.stringify(veri),
      }).then(() => {
        this.$snotify.success("Yatış notu güncellendi");
        this.getPatient(this.selectedPatientID);
      });
    },
    cancelNot() {
      this.editingNot = false;
      this.getPatient(this.selectedPatientID);
    },
    printYatisNotu() {
      const options = {
        name: "_blank",
        specs: ["height=800", "height=800", "titlebar=yes", "scrollbars=yes"],
        styles: ["https://pediatrim.net/print/yatis.css"],
      };
      this.$htmlToPaper("printYatisNotu", options);
    },
    // Epikriz
    onCopy() {
      this.$snotify.info("Klinik seyir kopyalandı");
    },
    // Progress Listesi
    selectProgress() {
      if (this.sprogress.length == this.selectedPatient[2].length) {
        this.sprogress = [];
      } else {
        this.sprogress = [];
        this.selectedPatient[2].forEach((element) => {
          this.sprogress.push(element);
        });
      }
    },
    printProgress() {
      const options = {
        name: "_blank",
        specs: ["height=800", "height=800", "titlebar=yes", "scrollbars=yes"],
        styles: ["https://pediatrim.net/print/progress.css"],
      };
      this.$htmlToPaper("pra-prog", options);
    },
  },
  created() {
    //this.getList();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      var v = to.params.id != undefined ? to.params.id : -1;
      vm.getPatient(v, false);
      // vm.getList();
    });
  },
  beforeRouteUpdate(to, from, next) {
    var v = to.params.id != undefined ? to.params.id : -1;
    this.getPatient(v, false);
    // this.getList();
    next();
  },
};
</script>

<style lang="scss"></style>
